import React from 'react';
import {useLocation} from "react-router-dom";
import ReactModal from 'react-modal';
import { useSystemMessage } from '../../../hooks/useSystemMessage';
import icon05 from '../../../assets/images/ROOM_TaskFile_Re_05.png';
import { FileData } from '../../../types/types';
import { roomattachfileApi } from '../../../apis/roomattachfile/roomattachfileApi';
import {logError} from "../../../libs/utils/logError";
import useAppRouter from "../../../hooks/useAppRouter";

interface DeleteRoomAttachFileModalProps {
  file: FileData;
  onSubmitted: () => Promise<void>;
}

export const DeleteRoomAttachFileModal = (
  props: DeleteRoomAttachFileModalProps
) => {
  const { file, onSubmitted } = props;
  const { success } = useSystemMessage();
  const [disabled, setDisabled] = React.useState<boolean>(false);
  const location = useLocation();
  const { goto } = useAppRouter();

  const handleSubmit = async () => {
    setDisabled(true);
    try {
      await roomattachfileApi.delete(file.id, {});
      setDisabled(false);
      await success('ファイルを削除しました');
      await onSubmitted();
    } catch(e) {
      await logError(
        location.pathname,
        'タスクファイルの削除に失敗しました。',
        e
      );

      goto('internalServerError');
    }
  };

  return (
    <>
      <ReactModal
        isOpen
        ariaHideApp={false}
        onRequestClose={() => onSubmitted()}
        className="content"
        overlayClassName="overlay"
        shouldCloseOnOverlayClick
      >
        <div className="form-modal-container">
          <div className="form-modal-title">
            <h1 className="font-semibold">ファイル削除</h1>
            <button
              type="button"
              className="modal-close-btn"
              onClick={() => onSubmitted()}
            >
              <img src={icon05} alt="icon" />
            </button>
          </div>
          <div className="form-modal-content text-center">
            <h1 className="text-primary text-xl font-semibold">
              {`「${file.name}」を削除しますか？`}
            </h1>
          </div>
          <div className="form-modal-footer-container">
            <div className="form-modal-footer">
              <button
                className="btn-sub"
                type="button"
                onClick={() => onSubmitted()}
              >
                キャンセル
              </button>
              <button
                className="btn-primary"
                type="button"
                onClick={handleSubmit}
                disabled={disabled}
              >
                {disabled ? '○　削　除' : '削　除'}
              </button>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
};
